var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',_vm._g(_vm._b({},'IconBase',_vm.$props,false),_vm.$listeners),[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"19","height":"19","rx":"9.5","stroke":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }